<template>
  <el-dialog
    title="Stream Pod Data"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    @close="closeDialog()"
    width="500px"
    class="stream-pod-data"
  >
    <el-form label-position="top" :model="form" :rules="rules" ref="form">
      <el-form-item label="Destination" prop="destination">
        <el-select
          v-model="form.destination"
          placeholder="Please select Destination"
          class="wp-100"
        >
          <el-option
            v-for="item in destinationOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Pod Mask Mac ID" prop="podMaskMacId">
        <el-input
          v-model="form.podMaskMacId"
          placeholder="Please enter Pod Mask Mac ID"
        ></el-input>
      </el-form-item>
      <el-form-item label="Node Mask Mac ID" prop="nodeMaskMacId">
        <el-input
          v-model="form.nodeMaskMacId"
          placeholder="Please enter Node Mask Mac ID"
        ></el-input>
      </el-form-item>
      <el-collapse-transition>
        <div v-if="showProgressContainer" class="progress-container">
          <el-form-item label="Progress" prop="progress">
            <el-progress
              :percentage="progress"
              :status="progress === 100 ? 'success' : null"
              class="animation-progress"
            ></el-progress>
          </el-form-item>
          <el-form-item>
            <div v-if="progress < 100">
              <span class="mr-5">Time remaining:</span>
              <span v-if="progress === 0">--</span>
              <span v-else>{{ remainTime }}</span>
            </div>
            <div v-else>
              <span style="color: #67C23A">Send complete</span>
            </div>
          </el-form-item>
        </div>
      </el-collapse-transition>
    </el-form>
    <div slot="footer" class="footer-bar">
      <div class="footer-bar-button" @click="pause()" v-if="isPlaying">
        <img src="@/assets/pause.svg" />
        <div class="button-text">Pause</div>
      </div>
      <div
        class="footer-bar-button"
        @click="play()"
        :class="progress === 100 ? 'disabled-button' : ''"
        v-else
      >
        <img src="@/assets/play.svg" />
        <div class="button-text">Play</div>
      </div>
      <div class="footer-bar-button" @click="reset()">
        <img src="@/assets/backward.svg" />
        <div class="button-text">Reset</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import moment from 'moment-timezone'
import _ from 'lodash'
import swal from 'sweetalert'
import ApiService from '@/services/ApiService.js'
export default {
  data() {
    return {
      dialogVisible: false,
      index: '',
      form: {
        destination: 'develop',
        podMaskMacId: '',
        nodeMaskMacId: ''
      },
      rules: {
        destination: [
          {
            required: true,
            message: 'Please select Destination',
            trigger: 'blur'
          }
        ],
        podMaskMacId: [
          {
            required: true,
            message: 'Please enter Pod Mask Mac ID',
            trigger: 'blur'
          }
        ],
        nodeMaskMacId: [
          {
            required: true,
            message: 'Please enter Node Mask Mac ID',
            trigger: 'blur'
          }
        ]
      },
      destinationOptions: [
        {
          label: 'Develop',
          value: 'develop'
        },
        {
          label: 'Staging',
          value: 'staging'
        },
        {
          label: 'Production',
          value: 'production'
        }
      ],
      progress: 0,
      isPlaying: false, // is uploding data
      estimatedUploadCompleteTime: 0, // Estimated upload completion time
      remainTime: 0, // remain time
      timer: '', // Timer for calculating remaining time
      timeout: '', // Timeout to execute next upload
      rawData: [], // raw data from API
      nextHandleIndex: 0, // The next data about going to upload
      showProgressContainer: false // Show progress box
    }
  },
  methods: {
    openDialog(rawData) {
      this.dialogVisible = true
      this.rawData = rawData
    },
    closeDialog() {
      this.form = {
        destination: 'develop',
        podMaskMacId: '',
        nodeMaskMacId: ''
      }
      this.$refs.form.resetFields()
      this.reset()
      this.showProgressContainer = false
      this.dialogVisible = false
    },
    play() {
      if (this.progress >= 100) return
      this.$refs.form.validate(valid => {
        if (valid) {
          this.showProgressContainer = true
          this.isPlaying = true
          this.calcEstimatedUploadCompleteTime(this.nextHandleIndex)
          this.sendData(this.nextHandleIndex)
        }
      })
    },
    sendData(index) {
      if (!this.isPlaying) return false
      this.handleUploadData(index)
      if (index < this.rawData.length - 1) {
        this.moveToNext(index)
        this.nextHandleIndex += 1
        this.calcEstimatedUploadCompleteTime(this.nextHandleIndex)
      } else {
        this.isPlaying = false
      }
    },
    handleUploadData(index) {
      let data = this.rawData[index]
      let params = {
        destination: this.form.destination,
        data: {
          type: 'Node-Replay',
          nodeMac: this.form.nodeMaskMacId,
          podId: this.form.podMaskMacId,
          data: [
            {
              timestamp: moment()
                .tz(this.$store.state.pods.selectedUtcOffset)
                .format('YYYY-MM-DD HH:mm:ss'),
              rssi: -60,
              scan_rsp: 0,
              rawData: data.rawData
            }
          ]
        }
      }
      ApiService.SendEventData(params)
        .then(response => {
          if (response.data.success) {
            this.progress = _.round(
              ((index + 1) / this.rawData.length) * 100,
              2
            )
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    moveToNext(index) {
      let currentData = this.rawData[index]
      let nextData = this.rawData[index + 1]
      let interval = moment(nextData.timeStamp).diff(
        moment(currentData.timeStamp)
      )
      this.timeout = setTimeout(() => {
        this.sendData(index + 1)
      }, interval)
    },
    calcEstimatedUploadCompleteTime(index) {
      let timePeriod =
        moment(this.rawData[this.rawData.length - 1].timeStamp).diff(
          moment(this.rawData[index].timeStamp)
        ) / 1000
      this.estimatedUploadCompleteTime = moment()
        .add(timePeriod, 's')
        .format('YYYY-MM-DD HH:mm:ss')
      this.calcRemainTime()
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.timer = setInterval(() => {
        this.calcRemainTime()
      }, 1000)
    },
    calcRemainTime() {
      if (!this.estimatedUploadCompleteTime) return 0
      let time = moment(this.estimatedUploadCompleteTime).diff(moment(), 's')
      if (time < 0) time = 0
      let day = Math.floor(time / 86400)
      let hour = Math.floor((time - day * 86400) / 3600)
      let minute = Math.floor((time - day * 86400 - hour * 3600) / 60)
      let second = Math.round(time - day * 86400 - hour * 3600 - minute * 60)
      if (day) {
        this.remainTime =
          day +
          'd' +
          ' ' +
          (hour > 0
            ? hour + 'h' + ' ' + (minute > 0 ? minute + 'min' : '')
            : '')
      } else if (hour) {
        this.remainTime =
          hour +
          'h' +
          ' ' +
          (minute > 0
            ? minute + 'min' + ' ' + (second > 0 ? second + 's' : '')
            : '')
      } else if (minute) {
        this.remainTime =
          minute + 'min' + ' ' + (second > 0 ? second + 's' : '')
      } else {
        this.remainTime = second + 's'
      }
    },
    pause() {
      this.isPlaying = false
      clearInterval(this.timer)
      clearTimeout(this.timeout)
    },
    reset() {
      this.progress = 0
      this.nextHandleIndex = 0
      this.isPlaying = false
      this.remainTime = 0
      this.estimatedUploadCompleteTime = 0
      clearInterval(this.timer)
      clearTimeout(this.timeout)
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    clearTimeout(this.timeout)
  }
}
</script>

<style lang="scss" scoped>
.el-form--label-top::v-deep .el-form-item__label {
  padding: 0;
  line-height: 30px;
}
</style>
